import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('accident_benefits_set', '/accident_benefits_sets', 'benefits_set')
const reducer = generator.generate()

export default reducer
